// src/pages/PeriodicTablePage.tsx
// Updated to match Landing page styling with full viewport background
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import PeriodicTableApp2D from '../components/education/periodic-table/PeriodicTableApp2D';
import periodicTableBackgroundImg from '../assets/images/PeriodicTableBackground.webp';
import BackButton from '../components/common/BackButton';

const PageContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  position: relative;
  background-image: url(${periodicTableBackgroundImg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  overflow-y: auto;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 0;
  }
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
  padding: 2rem;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.primary};
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
`;

const Subtitle = styled.p`
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
`;

const PeriodicTablePage: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToEducation = () => {
    navigate('/education');
  };

  return (
    <PageContainer>
      <BackButton onClick={handleBackToEducation} />
      <ContentContainer>
        <Header>
          <Title>Interactive Periodic Table of Elements</Title>
          <Subtitle>
            Explore the chemical elements commonly used in construction materials and understand their properties
          </Subtitle>
        </Header>
        <PeriodicTableApp2D />
      </ContentContainer>
    </PageContainer>
  );
};

export default PeriodicTablePage; 